import React from "react";

import { IconProps } from "../../types/common";

const PriorityHighIcon = ({
  width = "16",
  height = "16",
  style,
  className,
  fillClassName,
  fillColor = "#E64040",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 16 16"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={fillColor!}
      className={fillClassName}
      d="M8.66667 12.5273V5.08065L11.92 8.33399C12.18 8.59399 12.6067 8.59399 12.8667 8.33399C13.1267 8.07399 13.1267 7.65399 12.8667 7.39399L8.47334 3.00065C8.34878 2.87582 8.17968 2.80566 8.00334 2.80566C7.82699 2.80566 7.65789 2.87582 7.53334 3.00065L3.13334 7.38732C2.87334 7.64732 2.87334 8.06732 3.13334 8.32732C3.39334 8.58732 3.81334 8.58732 4.07334 8.32732L7.33334 5.08065V12.5273C7.33334 12.894 7.63334 13.194 8.00001 13.194C8.36667 13.194 8.66667 12.894 8.66667 12.5273Z"
    />
  </svg>
);

export default PriorityHighIcon;
